import {
  FC,
  MouseEventHandler,
  PropsWithChildren,
  ReactNode,
  useState,
} from 'react';
import Image from 'next/image';
import { Text } from '@mofid-securities/uikit';
import {
  FlipCard,
  FlipCardBackFace,
  FlipCardFrontFace,
  TFlipCardState,
} from '@/components/atomic/FlipCard';
import PulseBadge from '@/components/PulseBadge/PulseBadge';
import LIcon from '@/layouts/Base/components/LIcon';
import { useVariant } from '@/unleash';
import { useBreakPointDown } from '@/hooks/breakPoint';
import { useHandleLoggedInUserDisplayWrapper } from './LoggedInUserDisplayWrapper.hooks';

interface IUserInfoWrapperProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  id?: string;
}

export const LoggedInUserDisplayWrapper: FC<
  PropsWithChildren<IUserInfoWrapperProps>
> = ({ children, onClick, id }) => {
  const [flipState, setFlipState] = useState<TFlipCardState>('front');
  const { user, showPulseBadge } = useHandleLoggedInUserDisplayWrapper();
  const { enabled: flipCardProfileEnabled, data } = useVariant(
    'web.general.flipCardProfile'
  );
  const isMdDown = useBreakPointDown('md');

  const heightAndWidth = isMdDown ? 48 : 40;

  const childrenElement: Record<TFlipCardState, ReactNode> = {
    front: children,
    back: data?.description ? (
      <Text className="text-[#11A699] " size={'xs'} weight={'medium'}>
        {data?.description}
      </Text>
    ) : (
      children
    ),
  };

  return (
    <div
      className="flex cursor-pointer items-center gap-x-2 md:w-full md:flex-col md:justify-center md:gap-y-4 lg:gap-y-1"
      id={id}
      onClick={onClick}
    >
      <div className="relative">
        <FlipCard
          autoFlip={flipCardProfileEnabled}
          height={heightAndWidth}
          timeInterval={(data?.timeIntervalInSecond || 5) * 1000}
          width={heightAndWidth}
          onFlipChange={setFlipState}
        >
          <FlipCardFrontFace>
            <LIcon
              className="md:h-10 md:w-10 md:bg-neutral-filled-tertiary-enabled"
              icon="profile_outline"
            />
            {showPulseBadge && flipState === 'front' && (
              <PulseBadge className="absolute right-0 top-0" />
            )}
          </FlipCardFrontFace>
          {data?.imageUrl && (
            <FlipCardBackFace>
              <Image
                alt="پروفایل"
                height={heightAndWidth}
                src={data?.imageUrl || ''}
                width={heightAndWidth}
              />
            </FlipCardBackFace>
          )}
        </FlipCard>
      </div>
      <div className="flex flex-col gap-y-1 md:text-center">
        <Text
          className="cursor-pointer text-sm font-demibold md:text-xxs lg:text-xs"
          color="blue"
          component="span"
        >
          {user?.displayName || ''}
        </Text>
        {childrenElement[flipState]}
      </div>
    </div>
  );
};
